import styled from 'styled-components';

import TermsSection from '_components/composed/sections/TermsSection';

const StyledTermsPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TermsPage = () => {
  return (
    <StyledTermsPage>
      <TermsSection />
    </StyledTermsPage>
  );
};

export default TermsPage;
